/* eslint-disable ember/require-computed-property-dependencies */
import { computed } from '@ember/object';

export function hasRole(role) {
  return computed(`session.person.roles.[]`, function () {
    return this.roles.has(role);
  });
}

export function hasAnyRole(...roles) {
  return computed(`session.person.roles.[]`, function () {
    return this.roles.hasAny(roles);
  });
}
